export default __webpack_public_path__ + "static/boot-camp-8aa54a1dfa3cf9bffbb1406ec7d2a717.png";